function FormatDate() {
    return function (inputDate, format) {
        var date = moment(inputDate, 'jYYYY/jMM/jDD').locale('fa').format(format);
        return date;
    }
}

module.exports = ngModule => {
    ngModule.filter('FormatDate', FormatDate);
};